const UIInitialState = {
  sideMenuOpen: true,
};

export const UIReducer = (state = UIInitialState, action) => {
  // eslint-disable-next-line
  const { type, payload } = action;

  switch (type) {
    case "TOGGLE_SIDE_MENU":
      return {
        ...state,
        sideMenuOpen: !state.sideMenuOpen,
      };

    default:
      return state;
  }
};
